import { AttachmentPromiseClient } from '@trustero/trustero-api-web/lib/attachment/attachment_grpc_web_pb'
import {
  AddDocumentRequest,
  DeleteDocumentRequest,
  Document as DocumentMsg,
  GetDocumentByOIDRequest,
  IDsQuery,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { Identifier } from '@trustero/trustero-api-web/lib/common/model_pb'
import { authorizedGrpcClientFactory } from '../adapter/grpcClient'

class AttachmentService {
  static addDocument(
    modelType,
    modelId,
    docType,
    mime,
    body,
    caption,
    auth,
    authDispatch,
  ) {
    const documentMsg = new DocumentMsg()
    documentMsg.setSubjectmodeltype(modelType)
    documentMsg.setSubjectmodelid(modelId)
    documentMsg.setDoctype(docType)
    documentMsg.setMime(mime)
    documentMsg.setBody(body)
    documentMsg.setCaption(caption)
    return authorizedGrpcClientFactory(
      AttachmentPromiseClient,
      auth,
      authDispatch,
    ).addDocument(new AddDocumentRequest().setDocument(documentMsg))
  }

  static deleteDocument(objectId, auth, authDispatch) {
    return authorizedGrpcClientFactory(
      AttachmentPromiseClient,
      auth,
      authDispatch,
    ).deleteDocument(new DeleteDocumentRequest().setDocumentId(objectId))
  }

  static getDocumentById(documentId, auth, authDispatch) {
    const objectIdMsg = new GetDocumentByOIDRequest()
    objectIdMsg.setId(documentId).setIncludeBody(true)
    return authorizedGrpcClientFactory(
      AttachmentPromiseClient,
      auth,
      authDispatch,
    ).getDocumentByOID(objectIdMsg)
  }

  static getDocumentsBySubjectIds(
    subjectModelIds,
    subjectModelType,
    beginTime,
    endTime,
    excludeBody,
    auth,
    authDispatch,
  ) {
    const identifiersMsg = subjectModelIds.map((modelId) => {
      const idMsg = new Identifier()
      idMsg.setModeltype(subjectModelType)
      idMsg.setModelid(modelId)
      return idMsg
    })
    const idsQueryMsg = new IDsQuery()
    idsQueryMsg.setSubjectidsList(identifiersMsg)
    idsQueryMsg.setBegintime(beginTime)
    idsQueryMsg.setEndtime(endTime)
    idsQueryMsg.setExcludebody(excludeBody)
    return authorizedGrpcClientFactory(
      AttachmentPromiseClient,
      auth,
      authDispatch,
    ).getDocumentsBySubjectIDs(idsQueryMsg)
  }
}

export default AttachmentService
